module.exports = __webpack_public_path__ + "img/202501_ace.ddca9912.jpg";